import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProperties = async (params = {}) => {
  const { data } = await api.get("/properties", { params });
  return data;
};

export const fetchProperty = async (id) => {
  const { data } = await api.get(`/properties/${id}`);
  return data;
};

export const submitProperty = async (payload) => {
  const { data } = await api.post("/properties", payload);
  return data;
};

export const submitEnquiry = async (payload) => {
  const { data } = await api.post("/enquiries", payload);
  return data;
};

export const fetchStats = async () => {
  const { data } = await api.get("/stats");
  return data;
};

export const chatQuery = async (message) => {
  const { data } = await api.post("/chat/query", { message });
  return data;
};

// Blog
export const fetchBlog = async () => (await api.get("/blog")).data;
export const fetchBlogPost = async (slug) => (await api.get(`/blog/${slug}`)).data;

// Admin
const adminHeaders = () => {
  const t = localStorage.getItem("wb_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};
export const adminLogin = async (email, password) => {
  const { data } = await api.post("/admin/login", { email, password });
  localStorage.setItem("wb_admin_token", data.access_token);
  return data;
};
export const adminLogout = () => localStorage.removeItem("wb_admin_token");
export const isAdminLoggedIn = () => !!localStorage.getItem("wb_admin_token");
export const adminMe = async () => (await api.get("/admin/me", { headers: adminHeaders() })).data;
export const adminStats = async () => (await api.get("/admin/stats", { headers: adminHeaders() })).data;
export const adminProperties = async (pending) => (await api.get("/admin/properties", { headers: adminHeaders(), params: pending ? { pending: true } : {} })).data;
export const adminApproveProperty = async (id) => (await api.post(`/admin/properties/${id}/approve`, {}, { headers: adminHeaders() })).data;
export const adminUpdateProperty = async (id, updates) => (await api.patch(`/admin/properties/${id}`, updates, { headers: adminHeaders() })).data;
export const adminBulkAction = async (ids, action) => (await api.post(`/admin/properties/bulk`, { ids, action }, { headers: adminHeaders() })).data;
export const adminDeleteProperty = async (id) => (await api.delete(`/admin/properties/${id}`, { headers: adminHeaders() })).data;
export const adminToggleFeature = async (id) => (await api.post(`/admin/properties/${id}/feature`, {}, { headers: adminHeaders() })).data;
export const adminEnquiries = async () => (await api.get("/admin/enquiries", { headers: adminHeaders() })).data;
export const adminUpdateEnquiry = async (id, updates) => (await api.patch(`/admin/enquiries/${id}`, updates, { headers: adminHeaders() })).data;
export const adminDeleteEnquiry = async (id) => (await api.delete(`/admin/enquiries/${id}`, { headers: adminHeaders() })).data;
export const adminAnalytics = async () => (await api.get("/admin/analytics", { headers: adminHeaders() })).data;
export const adminSearchProperties = async (params) => (await api.get("/admin/properties", { headers: adminHeaders(), params })).data;
export const adminGetPage = async (key) => (await api.get(`/pages/${key}`)).data;
export const adminSetPage = async (key, content) => (await api.put(`/admin/pages/${key}`, { content }, { headers: adminHeaders() })).data;
export const adminCreateBlog = async (payload) => (await api.post("/admin/blog", payload, { headers: adminHeaders() })).data;
export const adminDeleteBlog = async (id) => (await api.delete(`/admin/blog/${id}`, { headers: adminHeaders() })).data;
